import React from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { DateField, FunctionField, Labeled, ReferenceField, SimpleShowLayout, TextField } from "react-admin";
import { settings } from "app";
import { employeeRequests } from "api/employeeApi";
import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import { SectionTitle } from "features/SectionTitle";

const SessionExamGeneralInfo = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <>
      <SectionTitle
        title="Информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Специалност">
              <ReferenceField
                source="specialityIds"
                reference={administrationRequests.getSpecialitiesSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Дисциплина">
              <ReferenceField
                source="disciplineId"
                reference={administrationRequests.getDisciplinesSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Сесия">
              <ReferenceField
                source="academicSessionId"
                resource={studentRequests.getAcademicSessionsSelect()}
                reference={studentRequests.getAcademicSessionsSelect()}
              >
                <TextField source="sessionTypeText" />
              </ReferenceField>
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Тип изпит">
              <ReferenceField
                source="examTypeId"
                reference={administrationRequests.getExamTypesSelect()}
              >
                <TextField source="nameBg" />
              </ReferenceField>
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Бележка">
              <TextField
                source="note"
                emptyText="-"
              />
            </Labeled>
          </Grid>

          {/* </Grid>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : { ...settings.style.shadowBox, marginTop: "0.5rem" }}
        > */}
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Създаден от">
              <ReferenceField
                source="createdByUserId"
                reference={employeeRequests.getEmployeesSelect()}
                emptyText="-"
              >
                <FunctionField
                  render={rec =>
                    rec.secondName
                      ? `${rec.firstName} ${rec.secondName} ${rec.lastName}`
                      : `${rec.firstName} ${rec.lastName}`
                  }
                />
              </ReferenceField>
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Дата на създаване">
              <DateField
                source="createdOn"
                locales="bg-BG"
              />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Последно редактиран от">
              <ReferenceField
                source="updatedByUserId"
                reference={employeeRequests.getEmployeesSelect()}
                emptyText="-"
              >
                <FunctionField
                  render={rec =>
                    rec.secondName
                      ? `${rec.firstName} ${rec.secondName} ${rec.lastName}`
                      : `${rec.firstName} ${rec.lastName}`
                  }
                />
              </ReferenceField>
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Дата на последна редакция">
              <DateField
                source="updatedOn"
                emptyText="-"
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </>
  );
};

export default SessionExamGeneralInfo;
